import React from 'react';
import { ReactComponent as MusicNote } from '@assets/icons/music-note.svg';

/** Music note for the Background Music & Audio perk; there is no matching joykit icon. */
export const MusicNoteIcon = () => (
  <MusicNote
    width={24}
    height={24}
    aria-hidden="true"
    focusable="false"
    style={{ alignSelf: 'flex-start', flexShrink: 0 }}
  />
);
